<template>
  <div class="rootdiv" v-if="islogin" style="background-color: whitesmoke">
    <div class="menudiv">
      <div @click="About">
        <Cell title="帐号设置" class="cellstyle" to="/m_account_setting" is-link></Cell>
      </div>
      <div @click="About">
        <Cell title="安全设置" class="cellstyle" to="/m_security_setting" is-link></Cell>
      </div>
      <div @click="About">
        <Cell title="权限设置" class="cellstyle" to="/m_auth_setting" is-link></Cell>
      </div>
      <div @click="About">
        <Cell title="关于生日圈" class="cellstyle" style="margin-top: 1rem" is-link></Cell>
      </div>
    </div>
    <div class="bottomContent">
      <Button size="large" type="danger" class="logoutButton" @click="loginOut"><span>退 出</span></Button>
    </div>
    <Popup style="border-radius: 20px"
           v-model="popupVisible"
           popup-transition="popup-fade">
      <div class="popupdiv">
        <div><span>网站名称：生日圈</span></div>
        <br/>
        <div><span>网站地址：http(s)://www.birthcircle.cn</span></div>
        <br/>
        <div><span>网站备案：蜀ICP备2022006805号</span></div>
        <br/>
        <div><span>网站说明：生日圈旨在...阿巴阿巴</span></div>
        <br/>
        <div><span>开发者：&nbsp;&nbsp;&nbsp;jzb</span></div>
        <br/>
        <div><span>联系方式：QQ：&nbsp;326695773</span></div>
        <div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮箱：326695773@qq.com</span>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import {Cell, Popup} from "mint-ui";

export default {
  name: "SystemSetting",
  components: {
    Cell,
    Popup
  },
  data() {
    return {
      popupVisible: false,
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      islogin: localStorage.getItem('islogin'),
    }
  },
  methods: {
    About() {
      this.popupVisible = true
    },
    loginOut() {
      this.$messagebox.confirm("确定退出当前帐号吗?").then(action => {
        if (action === 'confirm') {
          localStorage.setItem('islogin', '0')
          let url = null
          let param = null
          let type = localStorage.getItem('accountType')
          let machineType = this.getMachineType()
          let account = localStorage.getItem('account')
          if (type === 'Phone') {
            url = '/api/phone/loginOut'
            param = {phoneNumber: account, platformType: machineType}
          } else if (type === 'Weibo') {
            param = {uid: account, platformType: machineType}
            url = '/api/weibo/loginOut'
          } else if (type === 'Baidu') {
            param = {unionid: account, platformType: machineType}
            url = '/api/baidu/loginOut'
          } else if (type === 'Alipay') {
            param = {userId: account, platformType: machineType}
            url = '/api/alipay/loginOut'
          } else if (type === 'QQ') {
            param = {openid: account, platformType: machineType}
            url = '/api/qq/loginOut'
          }
          this.$ajax({
            method: 'get',
            url: url,
            params: param,
            headers: {token: this.token}
          }).then((response) => {
            if (response.data.result) {
              localStorage.clear()
              this.$router.push('/m_login');
            } else {
              this.$messagebox.alert(response.data.message, '服务器返回错误')
            }
          }).catch(response => {
            this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.rootdiv {
  margin-top: -0.5rem;
}

.menudiv {
  margin-left: -0.5rem;
  margin-right: -0.5rem;

  .cellstyle {
    text-align: left;
  }
}

.bottomContent {
  margin-top: 2rem;

  Button {
    width: 100%;
    background-color: #d20e2b;
    font-size: 1.2rem;
    height: 40px;
  }
}

.popupdiv {
  margin: 1rem;
  width: 20rem;
  text-align: left;

  span {
    font-size: 1rem;
  }
}
</style>
